import { SafeDictionary } from "@insite/client-framework/Common/Types";
import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import {
    GetProductCollectionApiV2Parameter,
    ProductExpandTokens,
} from "@insite/client-framework/Services/ProductServiceV2";
import { getSearchDataModeActive } from "@insite/client-framework/Store/Context/ContextSelectors";
import {
    DispatchBeginLoadProducts,
    DispatchCompleteLoadProducts,
    DispatchLoadProducts,
    DispatchSetFilterQuery,
    DispatchSetParameter,
    DispatchUpdateIdByPath,
    DisplayProductsResult,
    GetUnfilteredProducts,
    HandleSortOrderDefault,
    LoadRealTimeInventory,
    LoadRealTimePrices,
    ParseQueryParameter,
    PopulateApiParameter,
    PrepageProductRecs,
    RemoveNotAvailableAttributeValues,
    RequestCatalogPageFromApi,
    ResetSortTypeIfNeeded,
    SendTracking,
    SetIsFiltered,
    SetUpProductInfos,
} from "@insite/client-framework/Store/Pages/ProductList/Handlers/DisplayProducts";

interface Parameter {
    queryString: string;
    path: string;
    isSearch: boolean;
}

interface CustomGetProductCollectionApiV2Parameter extends GetProductCollectionApiV2Parameter {
    _d: number;
}

interface Props {
    apiParameter: CustomGetProductCollectionApiV2Parameter;
    idByPath?: SafeDictionary<string>;
    result: DisplayProductsResult;
    pricingLoaded?: true;
    expandTokens?: ProductExpandTokens;
}

type HandlerType = Handler<Parameter, Props>;

export const SetExpandTokens: HandlerType = props => {
    props.expandTokens = ["attributes", "facets", "variantTraits", "badges", "properties"];

    if (getSearchDataModeActive(props.getState())) {
        props.expandTokens.push("scoreexplanation");
    }
};

export const CustomPopulateApiParameter: HandlerType = props => {
    props.apiParameter._d = new Date().getTime();
};

export const chain = [
    DispatchBeginLoadProducts,
    RequestCatalogPageFromApi,
    ParseQueryParameter,
    SetIsFiltered,
    SetExpandTokens,
    PopulateApiParameter,
    CustomPopulateApiParameter,
    HandleSortOrderDefault,
    DispatchSetParameter,
    DispatchLoadProducts,
    ResetSortTypeIfNeeded,
    RemoveNotAvailableAttributeValues,
    GetUnfilteredProducts,
    SetUpProductInfos,
    DispatchUpdateIdByPath,
    DispatchCompleteLoadProducts,
    DispatchSetFilterQuery,
    SendTracking,
    LoadRealTimePrices,
    LoadRealTimeInventory,
    PrepageProductRecs,
];

const displayProducts = createHandlerChainRunner(chain, "DisplayProducts");
export default displayProducts;
